import Api from '@/services/TelegramApi'

var headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
}
var fileHeaders = {
  "Accept": "application/json",
  "Content-Type": "multipart/form-data",
}

function get(path){
  return new Promise(function(resolve, reject){
    Api().get(path, {headers: headers})
    .then(function(response){
        if(response.data.ok){
          resolve(response.data.result)
        }else{
          reject(response.data.description)
        }
      })
    .catch(function(error){
      reject(error.response.data.description)
    })
  })
}

function post(path, data){
  return new Promise(function(resolve, reject){
    Api().post(path, data, {headers: headers})
    .then(function(response){
        if(response.data.ok){
          resolve(response.data.result)
        }else{
          reject(response.data.description)
        }
      })
    .catch(function(error){
      reject(error.response.data.description)
    })
  })
}

function postFile(path, data){
  return new Promise(function(resolve, reject){
    Api().post(path, data, {headers: fileHeaders})
    .then(function(response){
        if(response.data.ok){
          resolve(response.data.result)
        }else{
          reject(response.data.description)
        }
      })
    .catch(function(error){
      reject(error.response.data.description)
    })
  })
}

export default {
    getMe(token) {
      let path = '/bot' + token + '/getMe'
      return get(path)
    },
    getChat(token, chat_id) {
      let path = '/bot' + token + '/getChat?chat_id=' + chat_id
      return get(path)
    },
    leaveChat(token, chat_id) {
      let path = '/bot' + token + '/leaveChat?chat_id=' + chat_id
      return get(path)
    },
    getChatMember(token, chat_id, user_id) {
      let path = '/bot' + token + '/getChatMember?chat_id=' + chat_id + '&user_id=' + user_id
      return get(path)
    },
    setMyCommands(token, data){
      let path = '/bot' + token + '/setMyCommands'
      return post(path, data)
    },
    sendMessage(token, data){
      let path = '/bot' + token + '/sendMessage'
      data.append('parse_mode', 'HTML')
      return post(path, data)
    },
    sendPhoto(token, data){
      let path = '/bot' + token + '/sendPhoto'
      data.append('parse_mode', 'HTML')
      return postFile(path, data)
    },
    send(token, data, method){
      let path = '/bot' + token + '/' + method
      data['parse_mode'] = 'HTML'
      return post(path, data)
    }

}
